export const RATING_MAPPING = {
    0: 'UNRATED',
    5: 'G',
    6: 'PG',
    7: 'PG',
    8: 'PG',
    9: 'PG',
    10: 'PG',
    11: 'PG',
    12: 'PG',
    13: 'PG13',
    14: 'PG',
    15: 'RATED 16',
    16: 'NC16',
    17: 'RATED 18',
    18: 'M18',
    19: 'PG',
    21: 'R21',
    31: 'PG13',
    32: 'PG13',
    33: 'PG13',
    34: 'PG13',
    35: 'PG13',
    36: 'PG13',
    37: 'PG13',
    38: 'PG13',
    39: 'PG13',
    40: 'PG13',
    41: 'PG13',
    42: 'PG13',
    43: 'PG13',
    44: 'PG13',
    45: 'PG13',
    46: 'PG13',
    47: 'PG13',
    48: 'PG13',
    49: 'PG13',
    50: 'PG13',
    51: 'NC16',
    52: 'NC16',
    53: 'NC16',
    54: 'NC16',
    55: 'NC16',
    56: 'NC16',
    57: 'NC16',
    58: 'NC16',
    59: 'NC16',
    60: 'NC16',
    61: 'NC16',
    62: 'NC16',
    63: 'NC16',
    64: 'NC16',
    65: 'NC16',
    66: 'NC16',
    67: 'NC16',
    68: 'NC16',
    69: 'NC16',
    70: 'NC16',
    71: 'M18',
    72: 'M18',
    73: 'M18',
    74: 'M18',
    75: 'M18',
    76: 'M18',
    77: 'M18',
    78: 'M18',
    79: 'M18',
    80: 'M18',
    81: 'M18',
    82: 'M18',
    83: 'M18',
    84: 'M18',
    85: 'M18',
    86: 'M18',
    87: 'M18',
    88: 'M18',
    89: 'M18',
    90: 'M18',
    91: 'R21',
    92: 'R21',
    93: 'R21',
    94: 'R21',
    95: 'R21',
    96: 'R21',
    97: 'R21',
    98: 'R21',
    99: 'R21',
    100: 'R21',
    101: 'R21',
    102: 'R21',
    103: 'R21',
    104: 'R21',
    105: 'R21',
    106: 'R21',
    107: 'R21',
    108: 'R21',
    109: 'R21',
    110: 'R21',
    111: 'R21',
    112: 'R21',
    113: 'R21',
    171: 'NC16',
    172: 'NC16',
    173: 'NC16',
    174: 'NC16',
    175: 'NC16',
    176: 'NC16',
    177: 'NC16',
    178: 'NC16',
    179: 'NC16',
    180: 'NC16',
    181: 'NC16',
    182: 'NC16',
    201: 'M18',
    202: 'M18',
    203: 'M18',
    204: 'M18',
    205: 'M18',
    206: 'M18',
    207: 'M18',
    208: 'M18',
    209: 'M18',
    210: 'M18',
}
